import * as React from 'react';
import { SVGProps } from 'react';

const SvgAwards = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M8.53 3.824V3.25h22.305v.576c.005 1.48-.536 7.36-2.274 12.853-.868 2.746-2.019 5.336-3.507 7.225-1.48 1.88-3.237 3-5.35 3-2.121 0-3.883-1.12-5.368-2.998-1.492-1.889-2.646-4.477-3.518-7.222C9.075 11.194 8.53 5.313 8.53 3.824Z"
    />
    <path fill="currentColor" d="M21.01 26.331h-2.645v5.296h2.645V26.33Z" />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M13.202 22.359a8.931 8.931 0 0 1-6.58-2.648C2.515 15.586 2.494 8.113 2.5 7.796V6.477h15.87m12.13-.005h6.375V7.79c0 .318 0 7.79-4.126 11.916a8.941 8.941 0 0 1-6.57 2.653"
    />
    <path
      fill={props.fill}
      d="M9.102 36.875h18.526v-5.296h-13.21l-5.316 5.296Z"
    />
  </svg>
);

export default SvgAwards;
